export function useComCookie(key: any, config: any = {}) {
  return useCookie(key, useDomainConfig(config))
}
